
import { useState } from 'react';
import Hero from './components/Hero';
import VoiceAssistant from './components/VoiceAssistant';
import Services from './components/Services';
import Pricing from './components/Pricing';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      <Hero />
      <VoiceAssistant />
      <Services />
      <Pricing />
      <Portfolio />
      <Contact />
      <Footer />
    </div>
  );
}
